import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faLightbulb, 
  faHandshake, 
  faRocket, 
  faGlobe 
} from '@fortawesome/free-solid-svg-icons';

const AboutPage = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="bg-primary text-white py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-4">About Us</h1>
              <p className="lead">
                Driving digital transformation through innovative technology solutions since 2025. 
                We're passionate about helping businesses leverage technology to achieve their goals.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Story */}
      <section className="section-padding">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2 className="mb-4">Our Story</h2>
              <p>
                TechInnovate was founded with a clear mission: to help businesses harness the power of technology 
                to solve complex problems and drive growth. What began as a small team of passionate technologists 
                has grown into a leading technology solutions provider serving clients across various industries.
              </p>
              <p>
                Our journey started when our founders recognized a gap in the market: businesses needed more than 
                just technical expertise; they needed strategic partners who could understand their unique challenges 
                and develop tailored solutions to address them.
              </p>
              <p>
                Today, we bring together deep industry knowledge, technical excellence, and creative thinking to 
                deliver solutions that make a real difference for our clients. Our team of experts is constantly 
                learning and evolving to stay at the forefront of technological advancements, ensuring we can offer 
                the most innovative solutions.
              </p>
            </Col>
            <Col lg={6}>
              <img 
                src="/images/about-story.jpg" 
                alt="Our Team Collaboration" 
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Values */}
      <section className="section-padding bg-light-custom">
        <Container>
          <h2 className="section-title">Our Values</h2>
          <Row>
            <Col md={3} className="mb-4">
              <Card className="card-custom h-100 text-center">
                <Card.Body>
                  <div className="mb-4">
                    <FontAwesomeIcon icon={faLightbulb} size="3x" className="text-primary" />
                  </div>
                  <Card.Title>Innovation</Card.Title>
                  <Card.Text>
                    We're committed to pushing boundaries and exploring new ideas to solve complex challenges.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className="mb-4">
              <Card className="card-custom h-100 text-center">
                <Card.Body>
                  <div className="mb-4">
                    <FontAwesomeIcon icon={faHandshake} size="3x" className="text-primary" />
                  </div>
                  <Card.Title>Partnership</Card.Title>
                  <Card.Text>
                    We build lasting relationships with our clients, working collaboratively to achieve their goals.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className="mb-4">
              <Card className="card-custom h-100 text-center">
                <Card.Body>
                  <div className="mb-4">
                    <FontAwesomeIcon icon={faRocket} size="3x" className="text-primary" />
                  </div>
                  <Card.Title>Excellence</Card.Title>
                  <Card.Text>
                    We hold ourselves to the highest standards in everything we do, from code quality to client service.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className="mb-4">
              <Card className="card-custom h-100 text-center">
                <Card.Body>
                  <div className="mb-4">
                    <FontAwesomeIcon icon={faGlobe} size="3x" className="text-primary" />
                  </div>
                  <Card.Title>Impact</Card.Title>
                  <Card.Text>
                    We measure our success by the positive difference we make for our clients and communities.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Approach */}
      <section className="section-padding bg-light-custom">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <img 
                src="/images/our-approach.jpg" 
                alt="Our Approach" 
                className="img-fluid rounded shadow"
              />
            </Col>
            <Col lg={6}>
              <h2 className="mb-4">Our Approach</h2>
              <p className="mb-4">
                We believe that successful technology solutions are built on a deep understanding of our clients' businesses, 
                challenges, and goals. Our collaborative approach ensures that we deliver solutions that not only solve immediate 
                problems but also position our clients for long-term success.
              </p>
              
              <h5 className="mb-3">1. Understand</h5>
              <p className="mb-3">
                We start by listening. Our team works closely with you to understand your business, challenges, and objectives.
              </p>
              
              <h5 className="mb-3">2. Strategize</h5>
              <p className="mb-3">
                Based on our understanding, we develop a strategic approach that aligns technology solutions with your business goals.
              </p>
              
              <h5 className="mb-3">3. Implement</h5>
              <p className="mb-3">
                Our skilled developers and engineers bring the strategy to life, using agile methodologies to ensure adaptability.
              </p>
              
              <h5 className="mb-3">4. Optimize</h5>
              <p>
                We continuously monitor, measure, and refine our solutions to maximize their impact and value.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AboutPage;